import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import VueResource from "vue-resource";
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

const datepickerOptions = {}

import VueApexCharts from 'vue-apexcharts'


// bootstrap vue
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// font awesome
import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";
//sidebar
import VueSidebarMenu from "vue-sidebar-menu";
import Vue2Sidebar from "vue2-sidebar";

//main scss
import "./main.scss";

// Accounting.js
const accounting = require('accounting-js')

Vue.use(AirbnbStyleDatepicker, datepickerOptions);
Vue.use(Vue2Sidebar);
Vue.use(VueSidebarMenu);
Vue.component("icon", Icon);
Vue.use(BootstrapVue);
Vue.use(require('vue-moment'));

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false;


Vue.use(VueResource);
Vue.http.headers.common["Content-Type"] = "application/json";
Vue.http.headers.common["Access-Control-Allow-Origin"] = "*";
Vue.http.headers.common["Accept"] = "application/json, text/plain, */*";
Vue.http.headers.common["Access-Control-Allow-Headers"] =
    "Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin";

// Add currency vue filter.
Vue.filter('currency', function (value) {
    return accounting.formatMoney(value, {
        symbol: '',
        precision: 2
    })
});
Vue.filter('amount', function (value) {
    return accounting.formatMoney(value, {
        symbol: '',
        precision: 0
    })
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
